import isEmpty from 'lodash/isEmpty'
import isNil from 'lodash/isNil'
import isObject from 'lodash/isObject'
import isString from 'lodash/isString'

export const isEmptyAddressValue = (value: any) =>
  isNil(value) || (isString(value) && isEmpty(value)) || (isObject(value) && isEmpty(value))
